import { msg } from "../../../../locales/translate";
export const client_registration_form_director = {
	data: {
		full_name: "",
		date_of_birth: "",
		citizenship: "",
		residential_address: "",

		politicaly_exposed_person: "",
		$__politicaly_exposed_person_values: ["Yes", "No"],

		us_person: "",
		$__us_person_values: ["Yes", "No"],

		government_id: "",
		proof_of_address: "",
	}
};

export const client_registration_form_director_decorator = {
	model: {
		get $__full_name_label() { return msg("fullName_f13a64ba"); },
		get $__date_of_birth_label() { return msg("dateOfBirth"); },
		$__date_of_birth_type: "date",
		get $__citizenship_label() { return msg("citizenshipNationality"); },
		$__citizenship_type: "country",
		get $__residential_address_label() { return msg("residentalAddress"); },
		
		get $__politicaly_exposed_person_label() { return msg("areYouAPoliticallyExposedPersonPep"); },
		$__politicaly_exposed_person_type: "radio",
		get $__us_person_label() { return msg("areYouAUSPerson"); },
		$__us_person_type: "radio",

		get $__government_id_label() { return msg("governmentIssuedPhotoIdPassportNationalId"); },
		get $__government_id_subtitle() { return msg("forAtLeastTwoDirectors"); },
		$__government_id_type: "file",

		get $__proof_of_address_label() { return msg("proofOfAddressUtilityBillBankStatementOrOtherOfficialDocument3MonthsOld"); },
		get $__proof_of_address_subtitle() { return msg("forTheSameDirectors"); },
		$__proof_of_address_type: "file",
	},

	$__model_decorator: {
		blockless: true,

		blocks: [
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["full_name", "date_of_birth"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["citizenship", "residential_address"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["politicaly_exposed_person", "us_person"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr",
				order: ["government_id"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr",
				order: ["proof_of_address"],
			},
		],
		sx: { gap: "20px" },
	},
};
